require('./counters');

module.exports = 'counters';


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/counters/index.js
 ** module id = 82
 ** module chunks = 1
 **/